module.exports = __webpack_public_path__ + "static/img/1-2.e3ff681.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/1-2.png
// module id = X1mD
// module chunks = 0